module.exports = __webpack_public_path__ + "img/newBanner-01.b7b124f4.png";